import { Component } from '@angular/core';
import { SinglePlanPromoPriceComponent, TitlePriceVariant } from '@basket';
import {
  ButtonComponent,
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  IconComponent,
  ProgressionStepsComponent,
  TermsAndConditionsPanelComponent,
  TrustboxComponent,
} from '@components';
import { translation as dataAccessTranslation } from '@data-access';
import {
  CurrencyFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@i18n';
import { SinglePlanTableComponent } from '../../components/single-plan-table/single-plan-table.component';
import { translation } from '../../i18n/translation.constant';
import { SinglePlanSaleBaseComponent } from './single-plan-sale.base';

@Component({
  selector: 'app-single-plan-sale',
  imports: [
    ButtonComponent,
    CurrencyFormatPipe,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    IconComponent,
    ProgressionStepsComponent,
    SinglePlanPromoPriceComponent,
    SinglePlanTableComponent,
    TermsAndConditionsPanelComponent,
    TranslatePipe,
    TrustboxComponent,
  ],
  templateUrl: './single-plan-sale.component.html',
  styleUrl: './single-plan-sale.component.scss',
  providers: [
    provideTranslationDictionaryMapping(translation),
    provideTranslationDictionaryMapping(dataAccessTranslation),
  ],
})
export class SinglePlanSaleComponent extends SinglePlanSaleBaseComponent {
  protected readonly featureFlagVariant = 'control' as const;

  protected readonly TitlePriceVariant = TitlePriceVariant;
}
